const convertStrToBool = (value: string) => value === "true" ? true : false;

export const helpers = {
  convertStrToBool: convertStrToBool,
};
